import type { ActionsNetwork } from 'shared/store/actions'
import { actionNetworkError, fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import type { RootState } from 'shared/store/reducers'
import type {
    CategoryShortDTO,
    CategoryWithProductsDTO,
    MetaShortDTO
} from 'shared/types/api'
import type { Dispatch } from 'redux'
import { errors } from 'shared/utils'
import { pageMetadata } from 'shared/store/metadata'

type GetState = () => RootState

type ActionCatalogPageDataResponse = {
    type: 'PAGE_DATA_CATALOG_RESPONSE',
    data: {
        metaData: MetaShortDTO,
        categories: Array<CategoryShortDTO>
    }
}

type ActionProductsByCategoryIdResults = {
    type: 'CATEGORY_WITH_PRODUCTS_RESULTS',
    data: CategoryWithProductsDTO
}

type ActionProductsByCategoryReset = {
    type: 'CATEGORY_WITH_PRODUCTS_RESET'
}

type ActionSelectedAllergens = {
    type: 'SELECTED_ALLERGENS',
    data: {
        selectedAllergens: Array<string>,
        category: string
    }
}

type ActionCatalogError = {
    type: 'CATALOG_ERROR',
    error: boolean
}

const fetchCategoriesPageData = () =>
    fetchPageData(endpoints.pages.catalog, 'PAGE_DATA_CATALOG_RESPONSE')

const actionCategoryWithProductsResponse = (
    response: CategoryWithProductsDTO
): ActionProductsByCategoryIdResults => ({
    type: 'CATEGORY_WITH_PRODUCTS_RESULTS',
    data: response
})

const resetCategoryWithProducts = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({
            type: 'CATEGORY_WITH_PRODUCTS_RESET'
        })
    }
}

/* Need to send category for GA event */
const applySelectedAllergens = (selectedAllergens: Array<string>) => {
    return (dispatch: Dispatch<any>, getState: GetState) => {
        const { categoryWithProducts } = getState().categoriesPageState
        dispatch({
            type: 'SELECTED_ALLERGENS',
            data: {
                selectedAllergens: selectedAllergens,
                categoryId:
                    categoryWithProducts &&
                    (categoryWithProducts.categoryInfos?.categoryId ?? '')
            }
        })
    }
}

const actionError = (error: any): ActionCatalogError => ({
    type: 'CATALOG_ERROR',
    error
})

const getProductsByCategoryId = (categoryId: string) => {
    return (dispatch: Dispatch<any>) => {
        return ws
            .get(`${endpoints.pages.catalog}/${categoryId}`)
            .then(response => {
                const { data } = response
                if (data) {
                    dispatch(actionCategoryWithProductsResponse(data))
                    data.metaData && dispatch(pageMetadata(data.metaData))
                }
            })
            .catch(error => {
                console.error('Error getting products by categoryId', error)
                switch (error) {
                    case errors.NETWORK:
                        dispatch(
                            actionNetworkError({
                                type: errors.NETWORK
                            })
                        )
                        break
                    case errors.TIMEOUT:
                        dispatch(
                            actionNetworkError({
                                type: errors.TIMEOUT
                            })
                        )
                        break
                    default:
                        dispatch(actionError(error))
                        break
                }
            })
    }
}

export {
    fetchCategoriesPageData,
    getProductsByCategoryId,
    resetCategoryWithProducts,
    applySelectedAllergens,
    actionError
}

export type Action =
    | ActionCatalogPageDataResponse
    | ActionProductsByCategoryIdResults
    | ActionSelectedAllergens
    | ActionProductsByCategoryReset
    | ActionCatalogError
    | ActionsNetwork
